import { Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

interface LoaderI {
  type?: string;
  color?: any;
  size?: number;
  text?: string;
}

const loaderTextStyles = {
  fontSize: '14px',
  padding: '20px 0',
};

export const Loader = ({ type = 'table', color = 'grey', size, text }: LoaderI) => {
  if (type === 'section') {
    return (
      <Box
        sx={{
          height: '60vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#007bff',
        }}
      >
        <CircularProgress color={color} size={size} />
      </Box>
    );
  }
  if (type === 'table') {
    return (
      <Box
        sx={{
          height: '60vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#007bff',
          flexDirection: 'column',
        }}
      >
        <CircularProgress color={color} size={size} />
        <p style={loaderTextStyles}>{text}</p>
      </Box>
    );
  }
  if (type === 'button') {
    return (
      <Box
        sx={{
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '0 5px',
        }}
      >
        <CircularProgress color={color} size={24} />
      </Box>
    );
  }
  return null;
};
